import axios from "axios";

const PublicAPI = axios.create({
  headers: {
    "content-type": "application/json",
  },
});

export default PublicAPI;
